/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef, useRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import TeacherSearch from "./TeacherSearch";
import {
    Select,
    MenuItem,
    AppBar,
    Toolbar,
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormLabel,
    Checkbox,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    createTheme,
    ThemeProvider,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import RegisterFormAddr from './RegisterFormAddr';
import { MonthPicker } from '@mui/x-date-pickers';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styled from 'styled-components';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Input = styled('input')({
    display: 'none',
});

const itemsTheme = createTheme({
    components: {
        MuiTableRow: {
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                }
            }
        }
    }
})

// 등록하기 팝업
function ResumeAdd(props) {
    const { login, onCloseAddPop, tcidParent, resume_seq } = props;
    const token = localStorage.getItem("token");
    const [tmcd, setTmcd] = useState("");
    const [tcid, setTcid] = useState(tcidParent);
    const [rseq, setRseq] = useState(resume_seq);
    const [showTeacherSearch, setShowTeacherSearch] = useState(false);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState('');
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [image, setImage] = useState('');
    const [eseq, setEseq] = useState(0);
    const [education, setEducation] = useState('');
    const [sname, setSname] = useState('');
    const [major, setMajor] = useState('');
    const [degree, setDegree] = useState('');
    const [endate, setEndate] = useState(null);
    const [grdate, setGrdate] = useState(null);
    const [state, setState] = useState('');
    const [educationItems, setEducationItems] = useState([])
    const outsideRef = useRef(null);
    const [cseq, setCseq] = useState(0);
    const [company, setCompany] = useState('');
    const [department, setDepartment] = useState('');
    const [position, setPosition] = useState('');
    const [sdate, setSdate] = useState(null);
    const [edate, setEdate] = useState(null);
    const [workNow, setWorkNow] = useState(false);
    const [careerItems, setCareerItems] = useState([])
    const [ceseq, setCeseq] = useState(0);
    const [license, setLicense] = useState('');
    const [publisher, setPublisher] = useState('');
    const [date, setDate] = useState(null);
    const [certificateItems, setCertificateItems] = useState([])

    const onImageChange = (fileBlob) => {
        setFileName(fileBlob.name);
        const reader = new FileReader();
        reader.readAsDataURL(fileBlob);
        return new Promise((resolve) => {
            reader.onload = () => {
                setImage(reader.result);
                resolve();
            }
        })
        
    }

    console.log(fileName)

    const onChangeEducation = (e) => {
        setEducation(e.target.value);
    }

    const onChangeSName = (e) => {
        setSname(e.target.value);
    }

    const onChangeMajor = (e) => {
        setMajor(e.target.value);
    }

    const onChangeDegree = (e) => {
        setDegree(e.target.value);
    }

    const onChangeState = (e) => {
        setState(e.target.value);
    }

    const onChangeEndate = (newDate) => {
        setEndate(moment(newDate).format('YYYY-MM'))
    };

    const onChangeGrdate = (newDate) => {
        setGrdate(moment(newDate).format('YYYY-MM'))
    };

    // 학력 추가
    const addEducation = async () => {
        let result = await axios.post(configState.api + '/gympass_admin/resume_add_education', {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            resume_seq: resume_seq,
            education: education,
            sname: sname,
            major: major,
            degree: degree,
            endate: endate,
            grdate: grdate,
            state: state
        })
        if (result.data.success === 1) {
            setEseq(0);
            setEducationItems(result.data.educations);
            setEducation('')
            setSname('');
            setMajor('');
            setDegree('');
            setState('');
            setEndate(null);
            setGrdate(null);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    }

    // 학력 선택
    const selectEducation = (params) => {
        let { id, education, sname, major, degree, endate, grdate, state } = params;
        if (eseq === 0 || eseq !== id) {
            setEseq(id);
            setEducation(education);
            setSname(sname);
            setMajor(major);
            setDegree(degree);
            setEndate(endate);
            setGrdate(grdate);
            setState(state);
        }
        if (eseq !== 0 && eseq === id) {
            setEseq(0);
            setEducation('');
            setSname('');
            setMajor('');
            setDegree('');
            setEndate(null);
            setGrdate(null);
            setState('');
        }
    }

    // 학력 수정
    const editEducation = async () => {
        Swal.fire({
            text: '선택한 학력을 수정하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true
        })
            .then(async (result) => {
                if (result.isConfirmed) {
                    let result = await axios.post(configState.api + '/gympass_admin/resume_edit_education', {
                        token: token,
                        cid: login.cid,
                        level: login.level,
                        mcd: login.mcd,
                        resume_seq: resume_seq,
                        seq: eseq,
                        education: education,
                        sname: sname,
                        major: major,
                        degree: degree,
                        endate: endate,
                        grdate: grdate,
                        state: state
                    })
                    if (result.data.success === 1) {
                        Swal.fire('수정되었습니다.')
                            .then(() => {
                                setEseq(0);
                                setEducationItems(result.data.educations);
                                setEducation('')
                                setSname('');
                                setMajor('');
                                setDegree('');
                                setState('');
                                setEndate(null);
                                setGrdate(null);
                            })
                    } else {
                        Swal.fire(result.data.msg);
                        return;
                    }
                }
            })
    }
    
    // 학력 삭제
    const deleteEducation = async () => {
        Swal.fire({
            text: '선택한 학력을 삭제하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true
        })
            .then(async (result) => {
                if (result.isConfirmed) {
                    let result = await axios.post(configState.api + '/gympass_admin/resume_delete_education', {
                        token: token,
                        cid: login.cid,
                        level: login.level,
                        mcd: login.mcd,
                        resume_seq: resume_seq,
                        seq: eseq,
                    })
                    if (result.data.success === 1) {
                        Swal.fire('삭제되었습니다.')
                            .then(() => {
                                setEseq(0);
                                setEducationItems(result.data.educations);
                                setEducation('')
                                setSname('');
                                setMajor('');
                                setDegree('');
                                setState('');
                                setEndate(null);
                                setGrdate(null);
                            })
                    } else {
                        Swal.fire(result.data.msg);
                        return;
                    }
                }
            })

    }

    const onChangeCompany = (e) => {
        setCompany(e.target.value);
    }

    const onChangeDepartment = (e) => {
        setDepartment(e.target.value);
    }

    const onChangePosition = (e) => {
        setPosition(e.target.value);
    }

    const onChangeSdate = (newDate) => {
        setSdate(moment(newDate).format('YYYY-MM'))
    };

    const onChangeEdate = (newDate) => {
        setEdate(moment(newDate).format('YYYY-MM'))
    };

    const handleChange = (e) => {
        if(workNow === false) {
            setWorkNow(true);
            setEdate(null);
        } else {
            setWorkNow(false);
            setEdate(null);
        }
    }

    // 경력 추가
    const addCareer = async () => {
        let result = await axios.post(configState.api + '/gympass_admin/resume_add_career', {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            resume_seq: resume_seq,
            company: company,
            department: department,
            position: position,
            sdate: sdate,
            edate: edate,
            workNow: workNow,
        })
        if (result.data.success === 1) {
            setCseq(0);
            setCompany('');
            setDepartment('');
            setPosition('');
            setSdate(null);
            setEdate(null);
            setWorkNow(false);
            setCareerItems(result.data.careers);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    }

    const selectCareer = (params) => {
        let { id, company, department, position, sdate, edate, is_checked } = params;
        if (cseq === 0 || cseq !== id) {
            setCseq(id);
            setCompany(company);
            setDepartment(department);
            setPosition(position);
            setSdate(sdate);
            setEdate(edate);
            setWorkNow(is_checked);
        }
        if (cseq !== 0 && cseq === id) {
            setCseq(0);
            setCompany('');
            setDepartment('');
            setPosition('');
            setSdate(null);
            setEdate(null);
            setWorkNow(false);
        }
    }

    const editCareer = async () => {
        Swal.fire({
            text: '선택한 경력을 수정하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true,
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                let result = await axios.post(configState.api + '/gympass_admin/resume_edit_career', {
                    token: token,
                    cid: login.cid,
                    level: login.level,
                    mcd: login.mcd,
                    resume_seq: resume_seq,
                    seq: cseq,
                    company: company,
                    department: department,
                    position: position,
                    sdate: sdate,
                    edate: edate,
                    workNow: workNow,
                })
                if(result.data.success === 1) {
                    Swal.fire('수정되었습니다.')
                    .then(() => {
                        setCseq(0);
                        setCompany('');
                        setDepartment('');
                        setPosition('');
                        setSdate(null);
                        setEdate(null);
                        setWorkNow(false);
                        setCareerItems(result.data.careers);
                    })
                } else {
                    Swal.fire(result.data.msg);
                    return;
                }
            }
        })
    }

    const deleteCareer = async () => {
        Swal.fire({
            text: '선택한 경력을 삭제하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                let result = await axios.post(configState.api + '/gympass_admin/resume_delete_career', {
                    token: token,
                    cid: login.cid,
                    level: login.level,
                    mcd: login.mcd,
                    resume_seq: resume_seq,
                    seq: cseq,
                })
                if(result.data.success === 1) {
                    Swal.fire('삭제되었습니다.')
                    .then(() => {
                        setCseq(0);
                        setCompany('');
                        setDepartment('');
                        setPosition('');
                        setSdate(null);
                        setEdate(null);
                        setWorkNow(false);
                        setCareerItems(result.data.careers);
                    })
                } else {
                    Swal.fire(result.data.msg);
                    return;
                }
            }
        })
    }

    const onChangeLicense = (e) => {
        setLicense(e.target.value)
    };
   
    const onChangePublisher = (e) => {
        setPublisher(e.target.value)
    };

    const onChangeAcdate = (newDate) => {
        setDate(moment(newDate).format('YYYY-MM'))
    };

    const addCertificate = async () => {
        let result = await axios.post(configState.api + '/gympass_admin/resume_add_certificate', {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            resume_seq: resume_seq,
            license: license,
            publisher: publisher,
            date: date,
        })
        if (result.data.success === 1) {
            setCeseq(0);
            setLicense('');
            setPublisher('');
            setDate(null);
            setCertificateItems(result.data.certificates);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    }

    const selectCertificate = (params) => {
        let { id, license, publisher, date } = params;
        if (ceseq === 0 || ceseq !== id) {
            setCeseq(id);
            setLicense(license);
            setPublisher(publisher);
            setDate(date);
        }
        if (ceseq !== 0 && ceseq === id) {
            setCeseq(0);
            setLicense('');
            setPublisher('');
            setDate(null);
        }
    }

    const editCertificate = async () => {
        Swal.fire({
            text: '선택한 자격을 수정하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true,
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                let result = await axios.post(configState.api + '/gympass_admin/resume_edit_certificate', {
                    token: token,
                    cid: login.cid,
                    level: login.level,
                    mcd: login.mcd,
                    resume_seq: resume_seq,
                    seq: ceseq,
                    license: license,
                    publisher: publisher,
                    date: date,
                })
                if(result.data.success === 1) {
                    Swal.fire('수정되었습니다.')
                    .then(() => {
                        setCeseq(0);
                        setLicense('');
                        setPublisher('');
                        setDate(null);
                        setCertificateItems(result.data.certificates);
                    })
                } else {
                    Swal.fire(result.data.msg);
                    return;
                }
            }
        })
    }

    const deleteCertificate = () => {
        Swal.fire({
            text: '선택한 자격을 삭제하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                let result = await axios.post(configState.api + '/gympass_admin/resume_delete_certificate', {
                    token: token,
                    cid: login.cid,
                    level: login.level,
                    mcd: login.mcd,
                    resume_seq: resume_seq,
                    seq: ceseq,
                })
                if(result.data.success === 1) {
                    Swal.fire('삭제되었습니다.')
                    .then(() => {
                        setCeseq(0);
                        setLicense('');
                        setPublisher('');
                        setDate(null);
                        setCertificateItems(result.data.certificates);
                    })
                } else {
                    Swal.fire(result.data.msg);
                    return;
                }
            }
        })
    }

    const onSubmit = async () => {
        const formData = new FormData();

        formData.append('fileName', fileName);
        // pt_resume
        formData.append('tcd', tmcd);
        formData.append('tcid', tcid);
        formData.append('name', name);
        formData.append('phone', phone);
        formData.append('resume_seq', resume_seq);

        if(fileName !== null) {
        let result = await axios.post(configState.api + "/gympass_admin/resume_add", formData);

        if (result.data.success !== 1) {
            Swal.fire(result.data.msg);
            return;
        } else {
            Swal.fire({ title: "등록되었습니다.", showCloseButton: true }).then(
                (result) => {
                    onCloseAddPop();
                }
            );
        }
    } else {Swal.fire('이미지를 선택하세요')}
};

    // MemberSearch
    const onShowTeacherSearchClick = () => {
        setShowTeacherSearch(true);
    };

    const onHideTeacherSearchClick = () => {
        setShowTeacherSearch(false);
    };

    const onAfterTeacherSearchClick = (params) => {
        const { id, name, phone } = params;
        setName(name);
        setTmcd(id);
        setPhone(phone);
    };

    const clickOutside = (e) => {
        if (outsideRef.current && !outsideRef.current.contains(e.target)) {
            setEducation('');
            setSname('');
            setMajor('');
            setDegree('');
            setEndate(null);
            setGrdate(null);
            setState('');
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', clickOutside);
        return () => {
            document.removeEventListener('mousedown', clickOutside);
        }
    })


    return (
        <Box>

            {/* 강사 찾기 */}
            <Dialog
                open={showTeacherSearch}
                onClose={() => { }}
                fullWidth={true}
                maxWidth="md"
            >
                <AppBar sx={{ position: "static" }}>
                    <Toolbar>
                        <Box sx={{ flexGrow: 1 }}>
                            <Typography style={{ fontSize: 18 }}>강사찾기</Typography>
                        </Box>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={onHideTeacherSearchClick}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <TeacherSearch
                    login={login}
                    tcidParent={tcid}
                    onAfterTeacherSearchClick={onAfterTeacherSearchClick}
                    onHideTeacherSearchClick={onHideTeacherSearchClick}
                />
            </Dialog>

            <Box
                css={css`
                    padding: 20px 60px;
                `}
            >
                {/* 기본정보 */}
                <Box
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '18px'
                    }}>
                    기본정보
                </Box>

                <Box sx={{ mt: 1 }}>
                    <Box sx={{ mt: 1 }}>
                        {(fileName === null || fileName === undefined) && (
                            <Box
                                sx={{
                                    border: '1px solid black',
                                    width: '104px',
                                    height: '104px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                }}>
                                104 X 104
                            </Box>
                        )}
                        {(fileName !== null && fileName !== undefined) && (
                            image && <Box
                                sx={{
                                    width: '104px',
                                    height: '104px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundImage: `url(${image})`,
                                    backgroundSize: 'cover',
                                    borderRadius: '50%',
                                }}>
                            </Box>
                        )}
                        <label
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginTop: '12px'
                            }}>

                            <Button variant='contained' component='span'>
                                이미지 첨부
                            </Button>
                            {(fileName === null || fileName === undefined) && (
                                <Box component='span' sx={{ marginLeft: '10px', fontSize: '14px' }}>이미지를 선택하세요</Box>
                            )}
                            {(fileName !== null && fileName !== undefined) && (
                                <Box component='span' sx={{ marginLeft: '10px', fontSize: '14px' }}>{fileName.name}</Box>
                            )}
                            <Input accept='image/jpeg' type='file' onChange={(e) => onImageChange(e.target.files[0])} sx={{ visibility: 'hidden' }} />


                        </label>
                        {/* <input accept='image/jpeg' type="file" onChange={onImageChange} /> */}

                    </Box>
                </Box>

                {/* 센터명 */}
                <Box
                    sx={{
                        marginTop: '10px'
                    }}>
                    <CenterSelect
                        login={login}
                        tcidParent={tcid}
                        setTcidParent={setTcid}
                    />
                </Box>

                {/* 이름 */}
                <Box
                    css={css`
                        margin-top: 10px;
                        display: flex;
                    `}
                >
                    <TextField
                        name="name"
                        label="이름 조회"
                        size="small"
                        sx={{
                            width: "260px",
                        }}
                        autoComplete="off"
                        value={name}
                        onClick={onShowTeacherSearchClick}
                    // onChange={(e) => setName(e.target.value)}
                    ></TextField>
                    <Box
                        sx={{
                            flexDirection: 'column',
                        }}>
                        <Box>강사등록이 안 되어 있는 경우, 조회가 불가능합니다.</Box>
                        <Box>강사등록 후 이력서 작성을 계속해주세요.</Box>
                    </Box>
                </Box>

                {/* 연락처 */}
                <Box
                    sx={{
                        marginTop: '10px',
                        marginBottom: '10px'
                    }}>
                    <TextField
                        autoComplete="off"
                        name="phone"
                        label="연락처"
                        size="small"
                        style={{
                            width: "260px",
                        }}
                        disabled
                        value={phone}
                    ></TextField>
                </Box>
                <Divider />
                <Divider />

                {/* 학력 */}
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                        }}>
                        <Box
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '18px',
                                marginTop: '10px'
                            }}>
                            학력
                        </Box>
                    </Box>

                    <Paper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>학교구분</TableCell>
                                    <TableCell>학교명</TableCell>
                                    <TableCell>전공명</TableCell>
                                    <TableCell>학위</TableCell>
                                    <TableCell>입학년월</TableCell>
                                    <TableCell>졸업년월</TableCell>
                                    <TableCell>졸업여부</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {educationItems.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                                            학력을추가해주세요.
                                        </TableCell>
                                    </TableRow>
                                )}
                                {educationItems.length > 0 && (
                                    educationItems.map((item, index) => {
                                        let id = item.id;
                                        return (
                                            <ThemeProvider theme={itemsTheme}>
                                                <TableRow key={index}
                                                    onClick={(id) => selectEducation({
                                                        id: item.id,
                                                        education: item.education,
                                                        sname: item.sname,
                                                        major: item.major,
                                                        degree: item.degree,
                                                        endate: item.endate,
                                                        grdate: item.grdate,
                                                        state: item.state,
                                                    })}
                                                    >
                                                    <TableCell>{item.education}</TableCell>
                                                    <TableCell>{item.sname}</TableCell>
                                                    <TableCell>{item.major}</TableCell>
                                                    <TableCell>{item.degree}</TableCell>
                                                    <TableCell>{item.endate}</TableCell>
                                                    <TableCell>{item.grdate}</TableCell>
                                                    <TableCell>{item.state}</TableCell>
                                                </TableRow>
                                            </ThemeProvider>
                                        )
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                marginTop: '10px'
                            }}>
                            {/* 학교구분 */}
                            <FormControl sx={{ width: '150px' }} size="small">
                                <InputLabel>학교구분</InputLabel>
                                <Select
                                    name="education"
                                    label="학교구분"
                                    onChange={(e) => onChangeEducation(e)}
                                    value={education}
                                >
                                    <MenuItem value="고등학교">고등학교</MenuItem>
                                    <MenuItem value="대학">대학(2, 3년제)</MenuItem>
                                    <MenuItem value="대학교">대학교(4년제)</MenuItem>
                                    <MenuItem value="대학원">대학원</MenuItem>
                                </Select>
                            </FormControl>

                            {/* 학교명 */}
                            <Box>
                                <TextField
                                    name="schoolname"
                                    label="학교명"
                                    size="small"
                                    sx={{
                                        width: "230px",
                                    }}
                                    autoComplete="off"
                                    value={sname}
                                    onChange={(e) => onChangeSName(e)}
                                ></TextField>
                            </Box>

                            {/* 전공명 */}
                            <Box>
                                <TextField
                                    name="major"
                                    label="전공명"
                                    size="small"

                                    sx={{
                                        width: "260px",
                                    }}
                                    autoComplete="off"
                                    value={major}
                                    onChange={(e) => onChangeMajor(e)}
                                ></TextField>
                                {education === '고등학교' &&
                                <Box
                                    sx={{
                                        marginLeft: '5px'
                                    }}>
                                    전공이 있는 경우만 작성해주세요.
                                </Box>
                                }
                            </Box>

                            {/* 학위 */}
                            {education !== '고등학교' &&
                                <FormControl sx={{ width: '100px' }} size="small">
                                    <InputLabel >학위</InputLabel>
                                    <Select
                                        name="degree"
                                        label="학위"
                                        onChange={(e) => onChangeDegree(e)}
                                        value={degree}
                                    >
                                        <MenuItem value="학사">학사</MenuItem>
                                        <MenuItem value="석사">석사</MenuItem>
                                        <MenuItem value="박사">박사</MenuItem>
                                        <MenuItem value="석박사">석박사</MenuItem>
                                    </Select>
                                </FormControl>
                            }
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                marginTop: '10px',
                                marginBottom: '10px',
                                justifyContent: 'space-between',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                }}
                            >

                                {/* 입학년월 */}
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                                    <MobileDatePicker
                                        allowSameDateSelection={true}
                                        views={['year', 'month']}
                                        value={endate}
                                        label="입학년월"
                                        renderInput={(params) => <TextField sx={{ width: '100px' }} size="small" {...params} />}
                                        onChange={onChangeEndate}
                                        inputFormat={"yyyy.MM"}
                                        autoComplete="off"
                                    />
                                </LocalizationProvider>

                                <Box>&nbsp;~&nbsp;</Box>

                                {/* 졸업년월 */}
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                                    <MobileDatePicker
                                        allowSameDateSelection={true}
                                        views={['year', 'month']}
                                        value={grdate}
                                        label="졸업년월"
                                        renderInput={(params) => <TextField sx={{ width: '100px' }} size="small" {...params} />}
                                        onChange={onChangeGrdate}
                                        inputFormat={"yyyy.MM"}
                                        autoComplete="off"
                                    />
                                </LocalizationProvider>

                                {/* 졸업여부 */}
                                <FormControl sx={{ width: '120px' }} size="small">
                                    <InputLabel >졸업여부</InputLabel>
                                    <Select
                                        name="state"
                                        label="졸업여부"
                                        onChange={(e) => onChangeState(e)}
                                        value={state}
                                    >
                                        <MenuItem value="졸업">졸업</MenuItem>
                                        <MenuItem value="졸업예정">졸업예정</MenuItem>
                                        <MenuItem value="재학중">재학중</MenuItem>
                                        <MenuItem value="휴학">휴학</MenuItem>
                                        <MenuItem value="수료">수료</MenuItem>
                                        <MenuItem value="중퇴">중퇴</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            {eseq === 0 &&
                                <Button variant='contained' onClick={addEducation}>학력추가</Button>
                            }
                            {eseq !== 0 &&
                                <Box>
                                    <Button variant='contained' onClick={() => editEducation()}>수정</Button>
                                    <Button variant='contained' onClick={() => deleteEducation()}>삭제</Button>
                                </Box>
                            }
                        </Box>
                        <Divider />
                    </Box>
                </Box>

                <Divider />

                {/* 경력 */}
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                        }}>
                        <Box
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '18px',
                                marginTop: '10px'
                            }}>
                            경력
                        </Box>
                    </Box>

                    <Paper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>회사명</TableCell>
                                    <TableCell>부서명</TableCell>
                                    <TableCell>직급/직책</TableCell>
                                    <TableCell>입사년월</TableCell>
                                    <TableCell>퇴사년월</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {careerItems.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                                            경력을추가해주세요.
                                        </TableCell>
                                    </TableRow>
                                )}
                                {careerItems.length > 0 && (
                                    careerItems.map((item, index) => {
                                        let id = item.id;
                                        return (
                                            <ThemeProvider theme={itemsTheme}>
                                                <TableRow key={index}
                                                    onClick={(id) => selectCareer({
                                                        id: item.id,
                                                        company: item.company,
                                                        department: item.department,
                                                        position: item.position,
                                                        sdate: item.sdate,
                                                        edate: item.edate,
                                                        is_checked: item.is_checked,
                                                    })}
                                                    >
                                                    <TableCell>{item.company}</TableCell>
                                                    <TableCell>{item.department}</TableCell>
                                                    <TableCell>{item.position}</TableCell>
                                                    <TableCell>{item.sdate}</TableCell>
                                                    <TableCell>{item.edate === 'Invalid date' ? '' : item.edate}</TableCell>
                                                </TableRow>
                                            </ThemeProvider>
                                        )
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                    <Box>
                        {/* 회사명 */}
                        <Box
                            sx={{
                                marginTop: '10px',
                                display: 'flex',
                            }}>
                            <TextField
                                name="company"
                                label="회사명"
                                size="small"

                                sx={{
                                    width: "260px",
                                }}
                                autoComplete="off"
                                value={company}
                                onChange={(e) => onChangeCompany(e)}
                            ></TextField>
                            <Box>
                                <TextField
                                    name="department"
                                    label="부서명"
                                    size="small"
                                    sx={{
                                        width: "200px",
                                    }}
                                    autoComplete="off"
                                    value={department}
                                    onChange={(e) => onChangeDepartment(e)}
                                ></TextField>
                                <Box
                                    sx={{
                                        marginLeft: '5px',
                                    }}>
                                    있는 경우만 작성해주세요.
                                </Box>
                            </Box>
                            <TextField
                                name="position"
                                label="직급/직책"
                                size="small"

                                sx={{
                                    width: "200px",
                                }}
                                autoComplete="off"
                                value={position}
                                onChange={(e) => onChangePosition(e)}
                            ></TextField>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                marginTop: '10px',
                                marginBottom: '10px',
                                justifyContent: 'space-between',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex'
                                }}
                            >

                                {/* 입사년월 */}
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                                    <MobileDatePicker
                                        allowSameDateSelection={true}
                                        views={['year', 'month']}
                                        value={sdate}
                                        label="입사년월"
                                        renderInput={(params) => <TextField sx={{ width: '100px' }} size="small" {...params} />}
                                        onChange={onChangeSdate}
                                        inputFormat={"yyyy.MM"}
                                        autoComplete="off"
                                    />
                                </LocalizationProvider>

                                <Box>&nbsp;~&nbsp;</Box>

                                {/* 퇴사년월 */}
                                {workNow === false &&
                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                                        <MobileDatePicker
                                            allowSameDateSelection={true}
                                            views={['year', 'month']}
                                            value={edate}
                                            label="퇴사년월"
                                            renderInput={(params) => <TextField sx={{ width: '100px' }} size="small" {...params} />}
                                            onChange={onChangeEdate}
                                            inputFormat={"yyyy.MM"}
                                            autoComplete="off"
                                        />
                                    </LocalizationProvider>
                                }

                                <FormControlLabel control={<Checkbox checked={workNow} onChange={(e) => handleChange(e)} />} label='재직중' />
                            </Box>
                            {cseq === 0 &&
                                <Button variant='contained' onClick={addCareer}>경력추가</Button>
                            }
                            {cseq !== 0 &&
                                <Box>
                                    <Button variant='contained' onClick={() => editCareer()}>수정</Button>
                                    <Button variant='contained' onClick={() => deleteCareer()}>삭제</Button>
                                </Box>
                            }
                        </Box>
                        <Divider />
                    </Box>
                </Box>

                {/* 자격 */}
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                        }}>
                        <Box
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '18px',
                                marginTop: '10px'
                            }}>
                            자격
                        </Box>
                    </Box>

                    <Paper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>자격증명</TableCell>
                                    <TableCell>발행기관명</TableCell>
                                    <TableCell>취득년월</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {certificateItems.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                                            자격을추가해주세요.
                                        </TableCell>
                                    </TableRow>
                                )}
                                {certificateItems.length > 0 && (
                                    certificateItems.map((item, index) => {
                                        let id = item.id;
                                        return (
                                            <ThemeProvider theme={itemsTheme}>
                                                <TableRow key={index}
                                                    onClick={(id) => selectCertificate({
                                                        id: item.id,
                                                        license: item.license,
                                                        publisher: item.publisher,
                                                        date: item.date,
                                                    })}
                                                    >
                                                    <TableCell>{item.license}</TableCell>
                                                    <TableCell>{item.publisher}</TableCell>
                                                    <TableCell>{item.date}</TableCell>
                                                </TableRow>
                                            </ThemeProvider>
                                        )
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                    <Box>
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}>
                                {/* 자격증명 */}
                                <Box
                                    sx={{
                                        marginTop: '10px',
                                        marginBottom: '10px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}>
                                    <TextField
                                        name="license"
                                        // helperText='급수나 점수가 있는 경우 같이 적어주세요.'
                                        label="자격증명"
                                        size="small"

                                        sx={{
                                            width: "260px",
                                        }}
                                        autoComplete="off"
                                        value={license}
                                        onChange={(e) => onChangeLicense(e)}
                                    ></TextField>

                                    {/* 발행기관명 */}
                                    <TextField
                                        name="publisher"
                                        label="발행기관명"
                                        size="small"
                                        sx={{
                                            width: "260px",
                                        }}
                                        autoComplete="off"
                                        value={publisher}
                                        onChange={(e) => onChangePublisher(e)}
                                    ></TextField>

                                    {/* 취득년월 */}
                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                                        <MobileDatePicker
                                            allowSameDateSelection={true}
                                            views={['year', 'month']}
                                            value={date}
                                            label="취득년월"
                                            renderInput={(params) => <TextField sx={{ width: '100px' }} size="small" {...params} />}
                                            onChange={onChangeAcdate}
                                            inputFormat={"yyyy.MM"}
                                            autoComplete="off"
                                        />
                                    </LocalizationProvider>
                                </Box>

                                <Box>
                                {ceseq === 0 &&
                                <Button variant='contained' onClick={addCertificate}>자격추가</Button>
                            }
                            {ceseq !== 0 &&
                                <Box>
                                    <Button variant='contained' onClick={() => editCertificate()}>수정</Button>
                                    <Button variant='contained' onClick={() => deleteCertificate()}>삭제</Button>
                                </Box>
                            }
                                </Box>
                            </Box>
                            <Divider />
                        </Box>
                    </Box>
                </Box>

                <Box
                    css={css`
            text-align: center;
            margin-top: 30px;
          `}
                >
                    <Button variant="contained" onClick={onSubmit}>
                        등록완료
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        css={css`
              margin-left: 10px;
            `}
                        onClick={onCloseAddPop}
                    >
                        취소
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
export default ResumeAdd;

// ======================= //
// 즐겨찾는 센터
// ======================= //
function FcenterSelect(props) {

    const { setFcid } = props;
    const [rows, setRows] = useState([]);
    const load_data = async () => {
        let result = await axios.post(configState.api + "/gympass_admin/center_list");
        setRows(result.data);
    }

    useEffect(() => {
        load_data();
    }, [])

    return <FormControl size="small" sx={{ width: 280 }}>
        <InputLabel>즐겨 찾는 센터</InputLabel>
        <Select onChange={(e) => { setFcid(e.target.value) }}>
            {
                rows.map((item, index) => {
                    return <MenuItem key={index} value={item.cid}>{item.center}:{item.location}</MenuItem>
                })
            }
        </Select>
    </FormControl>
}